import { render, staticRenderFns } from "./AcoesInabilitar.vue?vue&type=template&id=10986c6d&scoped=true"
import script from "./AcoesInabilitar.vue?vue&type=script&lang=js"
export * from "./AcoesInabilitar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10986c6d",
  null
  
)

export default component.exports